import { useEffect } from 'react';
import {useDispatch} from 'react-redux';
import { setWhatsappBottomSpacing } from '../redux/actions';

const useWhatsAppButtonPosition = (margin: string) => {
    const dispatch = useDispatch()
    
    useEffect(() => {
        dispatch(setWhatsappBottomSpacing(margin))
        return () => {
            dispatch(setWhatsappBottomSpacing(undefined))
        }
    }, [dispatch, margin])
}

export   { useWhatsAppButtonPosition }